export const removeSpecialCharacters = (string) => {
  var er = /[^a-z0-9]/gi;
  string = string.replace(er, "");

  return string;
};
